module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Add-user-089022bdfe27b723e97d8438d549ed25.svg";